import React from 'react'

const NotFoundPage = () => <div>Page not found</div>

export default NotFoundPage
